import * as React from 'react';
import illlustration from '../../assets/images/intro.svg'

interface WalkthroughIntroProps {
  next: () => void
  skip: () => void
}

class WalkthroughIntro extends React.Component<WalkthroughIntroProps> {
  public render () {
    return (
      <div className='walkthrough-intro-wrap'>
        <div className='walkthrough-intro-header'>
          <img src={illlustration} alt='Intro to Stackr' />
        </div>
        <div className='walkthrough-intro-content'>
          <h1>Build your long-term wealth with Stackr</h1>
          <p>Using this onboarding tool, you can experiment with different investment choices and find something that matches up <b>your</b> long-term investment goals.</p>
          <p>To get you get started, we'd like to walk you through the options that we offer and the decisions you'll need to make.</p>

          <div className='intro-buttons-wrap'>
            <button className='button primary-button' onClick={this.props.next}>Get started</button>
          </div>

          <p><small>If you'd prefer to figure it out yourself, you can go straight to the tool (don't worry you can always come back to this later if you like).</small></p>
          <button className='button link-button' onClick={this.props.skip}>Skip all</button>
        </div>
      </div>
    );
  }
}

export default WalkthroughIntro;
